import React, { Component } from "react";
import PagoServicioService from "../../../services/pagoServicios/pagoServicioService";
import { trackPromise } from 'react-promise-tracker';
import { formatoSeparadorMiles, formatoSeparadorMilesValue, agregarBarra } from '../../generico/utils/FormatoInput'
import Popup from "react-popup";
import PronetTitulo from "./PronetTitulo"
import { habilitarInputSeleccionado } from "../../generico/utils/Tabla";
import history from "../login/history";
import authService from "../../../services/login/auth.service";
import ConfigService from "../../../services/configuracion/ConfigService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight, faMoneyCheckDollar } from "@fortawesome/free-solid-svg-icons";
import CabeceraWizard from "./CabeceraWizard"

export default class PronetPaso2 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      codigo: props.codigo,
      datosFormulario: props.resultadoPaso1, 
      buscar: undefined,
      datosCliente: [],
      detalleCuotas: undefined,
      formularioUnico: [],
      cuotas: [],
      cabecera: [],
      label: "",
      detalleCuota: "NO",
      valor: "",
      tipoTrx: undefined,
      disableSgte: true

    };

    
  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });


  componentDidMount() {
   

  }


  detalles = () => {
    if (this.state.buscar === undefined) {
      //  this.setState({ buscar: this.props.buscar });
      trackPromise(        
        PagoServicioService.getDatosConsultaPronet(this.state.codigo, this.props.resultadoPaso1)
          .then((consulta) => {
            console.log(consulta);
            var jsonData = JSON.parse(JSON.stringify(consulta.data));

            if (jsonData.codRetorno !== "0") {
              Popup.queue(this.notifiPopup("Info", jsonData.desRetorno));
              this.previousStep.click()
              return;
            }
            var datoCliente = jsonData.campo;
            var detallado = jsonData.detalle;
            var cantidadDetalles = 0;
            if(detallado !== null){
              cantidadDetalles = detallado.length;
            }
            
            var esGrilla = false;
            if (datoCliente === null && cantidadDetalles === 1) {
              datoCliente = [];
              esGrilla = false;
              var datos = JSON.parse(JSON.stringify(jsonData.detalle));
             
              var detCuotas = [];
              var valores = JSON.parse(JSON.stringify(datos[0].campo));
              this.setState({ formularioUnico: valores });

              this.setState({ detalleCuota: "NO", esGrilla: esGrilla, tipoTrx: jsonData.tipoTrx, buscar: this.props.buscar, valorMonto: undefined, codigoServicio: jsonData.codServicio, disableSgte: false });
            }
            else if(jsonData.detalle === null){
              datoCliente = [];
              esGrilla = false;
              var datos = JSON.parse(JSON.stringify(jsonData.campo));
             
              var detCuotas = [];
              var valores = JSON.parse(JSON.stringify(datos));
              this.setState({ formularioUnico: valores });

              this.setState({ detalleCuota: "NO", esGrilla: esGrilla, tipoTrx: jsonData.tipoTrx, buscar: this.props.buscar, valorMonto: undefined, codigoServicio: jsonData.codServicio, disableSgte: false });
            }
            else if(datoCliente === null && cantidadDetalles > 1){
              datoCliente = [];
              esGrilla = true;
              var detalleCuotas = jsonData.detalle;
              var detCuotas = [];

              for (var i = 0; i < detalleCuotas.length; i++) {

                var detalle = JSON.parse(JSON.stringify(detalleCuotas[i]));
                 
                   for (var c = 0; c < detalle.campo.length; c++) {
                      var campoActual =detalle.campo[c]
                    if (campoActual.format === "DATE" &&  !campoActual.value.includes("/")) {
                 
                      campoActual.value = agregarBarra(campoActual.value)
                      
                    }
                    if (campoActual.format === "MONEY" &&  !campoActual.value.includes(".")) {
                 
                      campoActual.value = formatoSeparadorMilesValue(campoActual.value)
                      
                    }
                    if (campoActual.type === "OPTION" &&  campoActual.options !== null) {
                 
                      campoActual.value = campoActual.options[0].option[0].name;
                      
                    }

                    detalle.campo[c] = campoActual
                   }
               

                var detCabecera = [];
                var indCab = 0;
                detCuotas.push(detalle);
                for (var j = 0; j < detalle.campo.length; j++) {
                  var detCampo = JSON.parse(JSON.stringify(detalle.campo[j]))

                  detCabecera[indCab] = detCampo.label;
                  indCab++
                }
              }
              this.setState({ datosCliente: datoCliente, detalleCuotas: jsonData.detalle, label: null, valor: null, cuotas: detCuotas, cabecera: detCabecera, detalleCuota: "NO", esGrilla: esGrilla, tipoTrx: jsonData.tipoTrx, buscar: this.props.buscar, valorMonto: undefined, codigoServicio: jsonData.codServicio });
            }
            else {
              esGrilla = true;
              var detalleCuotas = jsonData.detalle;
              var detCuotas = [];
              var indice = 0;
              var datos = JSON.parse(JSON.stringify(datoCliente[0]));

              for (var i = 0; i < detalleCuotas.length; i++) {

                var detalle = JSON.parse(JSON.stringify(detalleCuotas[i]));
                 
                   for (var c = 0; c < detalle.campo.length; c++) {
                      var campoActual =detalle.campo[c]
                    if (campoActual.format === "DATE" &&  !campoActual.value.includes("/")) {
                 
                      campoActual.value = agregarBarra(campoActual.value)
                      
                    }
                    if (campoActual.format === "MONEY" &&  !campoActual.value.includes(".")) {
                 
                      campoActual.value = formatoSeparadorMilesValue(campoActual.value)
                      
                    }
                    if (campoActual.type === "OPTION" &&  campoActual.options !== null) {
                 
                      campoActual.value = campoActual.options[0].option[0].name;
                      
                    }

                    detalle.campo[c] = campoActual
                   }
               

                var detCabecera = [];
                var indCab = 0;
                detCuotas.push(detalle);
                for (var j = 0; j < detalle.campo.length; j++) {
                  var detCampo = JSON.parse(JSON.stringify(detalle.campo[j]))

                  detCabecera[indCab] = detCampo.label;
                  indCab++
                }
              }
              this.setState({ datosCliente: datoCliente, detalleCuotas: jsonData.detalle, label: datos.label, valor: datos.value, cuotas: detCuotas, cabecera: detCabecera, detalleCuota: "NO", esGrilla: esGrilla, tipoTrx: jsonData.tipoTrx, buscar: this.props.buscar, valorMonto: undefined, codigoServicio: jsonData.codServicio });
            }
            
          }
          ));

    }

  }




 

  agregarPunto = (valor) => {
    var cant = valor.length / 3
    var puntos = Math.trunc(cant)
    
    var resultado = ""
    for (var j = 0; j < puntos; j++) {
      var miles = valor.substring(valor.length - 3, valor.length)
      valor = valor.substring(0, valor.length - 3)
      if (resultado == "")
        resultado = miles + resultado
      else
        resultado = miles + "." + resultado

    }
    resultado = valor + resultado


    return resultado;
  };

  renderTableHeader() {
    if (this.state.cuotas !== undefined) {
      let header = Object.values(this.state.cabecera)
      return header.map((key, index) => {
        return <th key={key}>{key.toUpperCase()}</th>
      })
    }
  }


  selectorPopUp = (item) => {

    this.setState({ datosPopUp: item.campo, detalleCuota: "SI" });

  };



  handleChange = (e) => {
   
    this.setState({ valorMonto: e.target.value });

  };

  volver = (e) => {
    
    if (!this.state.esGrilla) {
      this.previousStep.click(); 
    }
    else{
      if (this.state.datosPopUp === undefined) { 
        this.previousStep.click();
      }
      if(this.state.detalleCuota === "NO" || this.state.detalleCuota === undefined){
        this.previousStep.click();
      }
      else{
        this.setState({ datosPopUp: undefined, detalleCuota: "NO" });

      }
    
    }
  }

  seleccionFilaTabla= (e, item) =>{
    //pintarFilaSeleccionada(e+"_row")

    //// inicializa campo editable
    this.setState({ valorMonto: undefined });
    //// control input editable
    habilitarInputSeleccionado(e + "_input")
    //// control radio
    var radio = document.getElementById(e + "_radio")
    radio.checked = true
    
    this.setState({ datosPopUp: item.campo, disableSgte:false});
  };

  mostrarDetalles() {
 
    var tieneDetalle = this.state.detalleCuota;
    if (this.state.esGrilla) {
      if (tieneDetalle === "SI") {
        var aux = this.state.datosPopUp
      
        return (
          <form id="det">
              <div className="col-md-12">
                <div className="row justify-content-md-center">
                  <div className="col-md-8" style={{border: "1px solid #e5e5e5", borderRadius: 10, padding: 30}}>
                    {aux.map(elemento =>
                      <div className="form-group">
                        <label className="input-label">{elemento.label}</label>
                        <input type="text" className="form-control input-box" name={elemento.name} onKeyUp={formatoSeparadorMiles} defaultValue={formatoSeparadorMilesValue(elemento.value)}
                          placeholder={elemento.label} disabled={elemento.editable == "false" ? true : false}
                          onBlur={(e) => { this.handleChange(e) }}
                        />
                      </div>
                    )}
                  </div>  
                </div>
              </div>           
          </form>
        );
      }
      else
        return (
          <table className="table" id='cuotas'>
            <thead>
              <tr>
                <th></th>
                {this.state.cabecera.map(element =>
                  <th>{element}</th>
                )}               
              </tr>
            </thead>

            <tbody>
              {this.state.cuotas.map((item, key) => (
                <tr id={key+"_row"} key={item.index} className="pago-servicio-registro-tabla">
                  <td onClick={(e) => { this.seleccionFilaTabla(key, item) }}><input type="radio" id={key + "_radio"} className="radioCuota" name="cuota" /></td>
                  {item.campo.map(element =>
                      
                      <td onClick={(e) => { this.seleccionFilaTabla(key, item) }}>
                        {
                          (element.editable==="true" && element.debitable==="true")
                          ?
                            <input type="text" id={key+"_input"} disabled="true" onKeyUp={formatoSeparadorMiles} defaultValue={element.value}
                            onBlur={(e) => { this.handleChange(e) }}/>
                          :
                            element.value
                        }
                      </td>
                  )}              
                </tr>
              ))}
            </tbody>

          </table>
        );
    }
    else {
      //console.log("es formulario unico")
      var formulario = [];
      //console.log(this.state.formularioUnico)
      for (var i = 0; i < this.state.formularioUnico.length; i++) {
        var datoCampo = this.state.formularioUnico[i];
        if (datoCampo.format === "DATE" &&  !datoCampo.value.includes("/")) {
         
          datoCampo.value = agregarBarra(datoCampo.value)
        }
        if (datoCampo.format === "MONEY") {
          if(datoCampo.value.indexOf(".")<0){
            datoCampo.value = formatoSeparadorMilesValue(datoCampo.value);
          }
            
        }
        formulario.push(datoCampo);
      }

      return (
        <form id="formulario">
            <div className="col-md-12">
              <div className="row justify-content-md-center">
                <div className="col-md-8">
                  {formulario.map(elem =>
                    <div className="form-group">
                      <label className="input-label">{elem.label}</label>
                      <input type="text" className="form-control input-box" name={elem.name} onKeyUp={formatoSeparadorMiles}
                        placeholder={elem.label} defaultValue={elem.value} disabled={elem.editable == "false" ? true : false}
                        onBlur={(e) => { this.handleChange(e) }}
                      />
                    </div>
                  )}  
                </div>
              </div>
            </div> 
        </form>
      );
    }
  }

  controlSeleccion(){
    if (!this.state.esGrilla){
      return false;
    }
    var validacion = false;
    if(!document.querySelector('input[name="cuota"]:checked')) {
        Popup.queue(this.notifiPopup("Info", 'Debe Seleccionar al Menos una Cuota para Continuar'));
        validacion = true;
    }
    
    return validacion
  }

  validatePagar = (e) => {
    var aux = []
    console.log(this.props);
    //// control radiobutton seleccionado
    if(this.controlSeleccion()===true){
      return
    }

    if (this.state.esGrilla) {
      aux = this.state.datosPopUp
  
      if (this.state.valorMonto !== undefined) {
        for (var i = 0; i < aux.length; i++) {
          if (aux[i].debitable === "true") {
            aux[i].value=this.state.valorMonto
          }
        }
      }
    
    } else {
      aux = this.state.formularioUnico
      
      if (this.state.valorMonto !== undefined) {
        for (var j = 0; j < aux.length; j++) {
          if (aux[j].debitable === "true") {
            aux[j].value=this.state.valorMonto
          }
        }
      }

    }
    this.props.respuestaPaso2(JSON.parse(JSON.stringify(aux)), this.state.tipoTrx, this.state.esGrilla, this.state.codigoServicio, this.state.datosCliente);
    this.setState({ msgError: "", detalleCuota: undefined });
    this.lastStep.click();

  };


  volverPagoServicio = (e) => {
    //history.push('/PagoServicio');
    history.push(ConfigService.getPathByName("pagoServicio")?.url);
    window.location.reload();
  }
  
 
  render() {
    
    if (this.props.currentStep !== 2) { // Prop: The current step
      return null
    }
    if (this.props.currentStep === 2) {
      this.detalles()
    }

    return (

      <div>
        {/******************* CABECERA WIZARD ***********************/}
        <div className="row">
          <CabeceraWizard
            nombre={this.props.nombre}
            tittle1="disabled"
            tittle2="current"
            tittle3="disabled"
            tittle4="disabled"
            tittle5="disabled"
            tittle6="disabled"
          />
          {/* <div className="steps clearfix" style={{marginBottom:5}}>
            <ul role="tablist">
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text current">{this.props.nombre}</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="current">
                <span>
                  <div className="title">
                    <span className="title_text">Consulta</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Cuenta</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Código de confirmación</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Verificación</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div> */}
        </div>

        <PronetTitulo img={this.props.img} empresa={this.props.empresa} />
        <hr/>

        {/******************* LOGICA PASOS ***********************/}
        <div className="row">
          <div className="col-md-12">
          {this.state.datosCliente.map(elem =>
                    <div className="row">
                      <div className="col-8">
                        <p style={{ marginBottom: 0 }}>
                          {elem.label}
                        </p>
                        <p>{elem.value}</p>
                      </div>
                  </div>
                  )} 
            
            <div className="row">
              <div className="col-md-12">
                <div className="table-responsive">
                  {this.mostrarDetalles()}
                </div>
              </div>
            </div>
          </div>

        </div>
        <hr />
        <div className="row">
        <div className="col-md-4 btn-consulta">
          <button className="btn btn-cu-secundary" onClick={this.volverPagoServicio}><FontAwesomeIcon icon={faMoneyCheckDollar} /> Pagar Otro Servicio</button> 
          </div>
        <div className="col-md-4 btn-consulta">
           
           <button className="btn btn-cu-quintary" onClick={this.volver} ><FontAwesomeIcon icon={faArrowLeft} /> Volver</button>
         </div>
          <div className="col-md-4">
          <button className="btn btn-cu-primary"  onClick={this.validatePagar} disabled={this.state.disableSgte} >Continuar  <FontAwesomeIcon icon={faArrowRight} /></button>
          </div>
          
        </div>
        <button
          hidden
          ref={(a) => (this.lastStep = a)}
          className="btn btn-cu-primary"
          onClick={this.props.nextStep}

        ></button>
        <button
          hidden
          ref={(a) => (this.previousStep = a)}
          className="btn btn-cu-primary"
          onClick={this.props.previousStep}

        ></button>

      </div>

    );
  }




}